// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  tenantSlug: 'demo',
  portalAdminBaseUrl: 'https://admin-quino.dev.tribalworldwide.gt',
  portalJugadoresBaseUrl: 'https://quinoplay.dev.tribalworldwide.gt',
  // portalAdminBaseUrl: 'http://localhost:4200',
  // portalJugadoresBaseUrl: 'http://localhost:5000',
  baseUrl: 'https://api-quino.dev.tribalworldwide.gt/',
  apiUrl: 'https://api-quino.dev.tribalworldwide.gt/api/v1/',
  claroUrl: 'https://api-quino.dev.tribalworldwide.gt/',
  claroApiUrl: 'https://api-quino.dev.tribalworldwide.gt/api/v1/',
  actions: {
    login: 'auth-web',
    me: 'me',
    all: 'all',
    bySport: 'by-sport',
    byPool: 'by-pool',
    show: 'show',
    store: 'store',
    storeScore: 'store-score',
    update: 'update',
    activate: 'active',
    deactivate: 'desactive',
    delete: 'delete',
    myPools: 'my-admin-pools',
    updateByReseller: 'update-by-reseller',
    deleteUser: 'delete-user',
    import: 'import-excel',
    countedList: 'counted-list',
    positions: 'positions',
    getResellers: 'get-resellers',
    updateByAdmin: 'update-by-admin',
    updateNicknameByAdmin: 'update-nickname-by-admin',
    updateMyProfile: 'update-profile',
    changePassword: 'change-password',
    inactive: 'inactive',
    refresh: 'refresh',
    forgotPassword: 'password-reset',
    updatePassword: 'update-password',
    completeProfile: 'complete-profile'
  },
  EMAIL_REGEX: '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
